export const validationWrongEmailAddress = "*Lütfen geçerli bir eposta giriniz.";
